import React from 'react'
import { Switch, Route } from "react-router-dom"
import AuthLogin from './login/login.page'
import Register from './register/register.page'
import RegisterSuccess from './register/register-success.page'
import Reset from './reset/reset.page'
import Forgot from './forgot/forgot.page'
import './common.styles.scss'

const AuthController = () => {
    return (
        <Switch>
            <Route path="/auth/login" component={AuthLogin} />
            <Route path="/auth/register/success" component={RegisterSuccess} />
            <Route path="/auth/register/:token" component={Register} />
            <Route path="/auth/forgot" component={Forgot} />
            <Route path="/auth/reset/:token" component={Reset} />
        </Switch>
    )
}

export default AuthController